import { atom } from 'jotai';
import apiClient from '../API/InkyAPI';
import { DiscoverItem, WheelContent } from '../Models/DiscoverItem';
import { FilterTuple } from '../Models/FilterTuple';
import { BrowseGenre } from '../Models/BrowseGenre';
import { BrowseData } from '../Models/BrowseData';
import { GenresAtom } from './GenreStore';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { ReleaseCalenderAPITypes, useReleaseCalendarAPI } from '../Kodansha/Hooks/useReleaseCalendarAPI';
import dayjs from 'dayjs';
import { Thumbnail } from '../Models/Thumbnail';
import { BrowseFilter } from '../Kodansha/BrowseComponent/BrowseComponent';
import axios from 'axios';


export const GenreArrayAtom = atom<BrowseGenre[]>([]);
// Stores the data for the wheels. Array. use ID as key to get correct
// item.
export const DiscoverArrayAtom = atom([]);
export const BrowseArrayAtom = atom<DiscoverItem[]>([]);
// Fetches the data required for the wheels
export const LatestAndGreatestWheelAtom = atom<DiscoverItem[]>([]);
export const UpcomingReleasesAtom = atom<DiscoverItem[]>([]);

export const FetchWheelCacheAtom = atom<DiscoverItem[]>([]);
export const FetchWheelAtom = atom(
    (get) => {
        return get(DiscoverArrayAtom);
    },
    async (get, set, id: number) => {
        const mutate = get(DiscoverArrayAtom);
        try {
            if (mutate[id]) {
                return mutate[id];
            }
            const res = await apiClient.getDiscoverByID(id, null, null, null, '500');
            mutate[id] = res.response;
            set(DiscoverArrayAtom, mutate);
        } catch (e) {
            console.error('[DiscoverStore] Could not fetch Wheel-data: ' + e.message, e);
            throw e;
        }
    },
);
export const BrowseCountAtom = atom<number>(0);


export const FetchBrowseAtom = atom((get) => {
        return get(BrowseArrayAtom);
    },
    async (get, set, data: BrowseData) => {
        //set(BrowseArrayAtom, []);
        let mutate = get(BrowseArrayAtom);
        try {
            const res = await apiClient.getDiscoverV2(data.currentType, data.currentSort, data.currentGenre, data.includeSeries, data.subCategory, null,
                data.start, data.maxItems, 500, data.scheduleStatus, data.newOnly, data.ageRating, data.completionStatus, null, data.publishStatus, data.sale,
                data.isOnSpotlight, data.category, data.format);
            mutate = res.response;
            set(BrowseArrayAtom, mutate);
            set(BrowseCountAtom, res.status.fullCount);
        } catch (e) {
            console.error('[DiscoverStore] Could not fetch Browse-data: ' + e.message, e);
            throw e;
        }
    },
);


let source;

export const FetchBrowseAtomV2 = atom((get) => {
        return get(BrowseArrayAtom);
    },
    async (get, set, data: BrowseFilter) => {
        console.debug('Browsefilter is', data);
        // If no data, do nothing.
        if (!data) {
            return;
        }

        // console.log('Race', FetchBrowseAtomV2Loading, source.token);
        if (source) {
            source?.cancel();
        }

        source = axios.CancelToken.source();

        //set(BrowseArrayAtom, []);
        // let mutate = get(BrowseArrayAtom);
        try {
            const res = await apiClient.getDiscoverV2Fixed(
                data.sortOrder,
                data.genreIds?.join(','),
                data.includeSeries,
                (data.subCategory === undefined)?undefined:data.subCategory?.toString(),
                source,
                (data.itemsPerPage ?? 24) * (data.paginationPageNumber ?? 0), data.itemsPerPage,
                -1,
                null,
                data.newOnly,
                data.ageRatings?.join(','),
                data.seriesStatus,
                data.publishStatus,
                data.isOnSale,
                data.isOnSpotlight,
                data.category,
                data.format,
                data?.isFree,
                data?.type,
                data?.publisherId,
            );
            // mutate = res.response;
            set(BrowseArrayAtom, res.response);
            set(BrowseCountAtom, res.status.fullCount);
        } catch (e) {
            console.error('[DiscoverStore] Could not fetch Browse-data: ' + e.message, e);
            throw e;
        }
    },
);

export const BrowseFilterAtom = atom<BrowseFilter>({
    ageRatings: undefined,
    category: undefined,
    genreIds: undefined,
    includeSeries: undefined,
    downloadablePriceTypes: undefined,
    shippablePriceTypes: undefined,
    isOnSale: undefined,
    isOnSpotlight: undefined,
    itemsPerPage: undefined,
    newOnly: undefined,
    paginationPageNumber: undefined,
    publishStatus: undefined,
    seriesStatus: undefined,
    sortOrder: undefined,
    subCategory: undefined,
    format: undefined,
    isFree: undefined,
    type: undefined,
    publisherId: undefined,
});

LatestAndGreatestWheelAtom.onMount = (set): void => {
    const data = new BrowseData();
    data.currentType = -1;
    data.includeSeries = false;
    data.subCategory = 'Volume';
    data.maxItems = 100;
    data.currentSort = 5;
    data.currentGenre = '';
    data.start = 0;
    data.ageRating = '';


    apiClient.getDiscoverV2(data.currentType, data.currentSort, data.currentGenre, data.includeSeries, data.subCategory, null,
        data.start, data.maxItems, null, null, true, data.ageRating, data.completionStatus, null, 4).then(res => {
        const today = dayjs().add(0, 'day');
        const endDate = dayjs().subtract(7, 'day');
        const items = res.response;
        const filtered = items.filter((item) => {
            return (dayjs(item.content.publishDate).isSame(today) || dayjs(item.content.publishDate).isAfter(endDate));
        });
        const final = filtered.slice(0, 5);
        set(final);
    }).catch(e => {
        console.error('[LatestAndGreatestWheelAtom] Could not fetch Discover-data: ' + e.message, e);
        throw e;
    });
// Hei.
};

UpcomingReleasesAtom.onMount = (set): void => {
    const type: ReleaseCalenderAPITypes = 'manga';
    apiClient.newReleaseCalendar(type)
        .then(res => {
            let digitalItems = (res as any).digital;
            let printItems = (res as any).print;
            /*        console.log(digitalItems);
                    console.log(printItems);*/

            let finalItemList: DiscoverItem[] = [];
            const digitalDiscoverItems = digitalItems.map(release => {
                const item = new DiscoverItem();
                item.type = 'product';
                item.content = new WheelContent();
                item.displayType = 'Volume';
                item.content.title = release.name + ' (Digital)';
                item.content.id = release.isPublished === true ? release.id : null;
                item.content.readableUrl = release.isPublished === true ? release.readableUrl : null;
                let thumb = new Thumbnail();
                thumb.url = release.thumbnailUrl;
                item.content.thumbnails = [];
                item.content.thumbnails.push(thumb);
                item.content.publishDate = dayjs(release.releaseDate).toISOString();
                finalItemList.push(item);
            });
            const printDiscoverItems = printItems.map(release => {
                const item = new DiscoverItem();
                item.type = 'product';
                item.content = new WheelContent();
                item.displayType = 'Volume';
                item.content.title = release.name + ' (Print)';
                item.content.id = release.isPublished === true ? release.id : null;
                item.content.readableUrl = release.isPublished === true ? release.readableUrl : null;
                let thumb = new Thumbnail();
                thumb.url = release.thumbnailUrl;
                item.content.thumbnails = [];
                item.content.thumbnails.push(thumb);
                item.content.publishDate = dayjs(release.releaseDate).toISOString();
                //console.log(dayjs(item.content.publishDate).toDate());
                finalItemList.push(item);
            });

            const sortedAsc = finalItemList.sort((a, b) => a.content.publishDate.localeCompare(b.content.publishDate));

            let final = sortedAsc.slice(0, 20);
            //console.log(sortedAsc);
            set(final);

        }).catch(e => {
        throw e;
    });
};


export const FetchGenreAtom = atom((get) => {
        return get(GenreArrayAtom);
    },
    async (get, set) => {
        let mutate = get(GenreArrayAtom);
        try {
            // console.log('Fetching genre...');
            const res = await apiClient.getAllGenres(null);
            mutate = res.data;

            const sorted = mutate.sort((a, b) => a.title.localeCompare(b.title));
            //console.log(mutate);
            set(GenreArrayAtom, sorted);
        } catch (e) {
            console.error('[DiscoverStore] could not fetch genre-data: ' + e.message, e);
            throw e;
        }
    },
);


